import { render } from "./LandingHero.vue?vue&type=template&id=2d598d37&scoped=true&ts=true"
import script from "./LandingHero.vue?vue&type=script&lang=ts"
export * from "./LandingHero.vue?vue&type=script&lang=ts"

import "./LandingHero.vue?vue&type=style&index=0&id=2d598d37&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d598d37"]])

export default __exports__